import React, { useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { ErrorPages, GlobalConstants } from "../constants/GlobalConstants";
import LMSTabFilter from "./LmsTabFilter";
import { Card, Icon } from "semantic-ui-react";
import BCError from "../BCError";
import BCLayout from "../BCLayout";
import { AuthWrapper } from "../../App";
import "../../styles/lms/filter-tabs.scss";
import "../../styles/lms/lms-landing-pages.scss";
import "../../styles/lms/lms-global.scss";
import LmsMessage from "./ui/LmsMessage";
import { useBCGlobalReducer } from "../BCGlobalStore";
import BCErrorBoundary from "../BCErrorBoundary";
import { useHistory } from "react-router-dom";
import { useLocalStorage } from "../../helpers/GlobalHelper";
import BCModal from "../ui/BCModal";
import LmsBreadcrumbsMenu from "./ui/LmsBreadcrumbsMenu";

const LmsPages = ({ children, hideMenu, ...props }) => {
  const history = useHistory();
  const [{ info, iFrameOptions }, globalDispatch] = useBCGlobalReducer();
  const iframeModalRef = useRef(null);
  const [iframeInitPath, setIframeInitPath] = useState("");
  const [iframeModalHeight, setIframeModalHeight] = useState(undefined as any);

  const closeIframeModal = () => {
    globalDispatch({
      type: GlobalConstants.BCStoreReducerCases.SET_IFRAME_OPTIONS
    });
  };

  const handleIframeLoad = () => {
    const iframeItem = iframeModalRef.current as any;
    if (iframeItem) {
      setIframeModalHeight(iframeItem.contentWindow.document.documentElement.scrollHeight);
    }
  };

  useEffect(() => {
    if (hideMenu && iframeInitPath) {
      switch (history.action) {
        case "PUSH":
          if (window.onpopstate) {
            window.onpopstate = null;
          }

          break;
        case "POP":
          if (iframeInitPath === history.location.pathname) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
              window.history.go(1);
              window.parent.postMessage("close iframe", process.env.REACT_APP_SPA_URL as any);
            };
          }
          else if (window.onpopstate) {
            window.onpopstate = null;
          }

          break;
        default:
          break;
      }
    }

    if (!iframeInitPath) {
      setIframeInitPath(history.location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (iframeModalRef?.current) {
      window.addEventListener(
        "message",
        (event) => {
          if (event.origin !== process.env.REACT_APP_SPA_URL) return;
          if (event.data === "close iframe") {
            closeIframeModal();
          }
        },
        false);
    }
  }, [iframeModalRef?.current]);

  const clearGlobalInfo = () => globalDispatch({
    type: GlobalConstants.BCStoreReducerCases.CLEAR_INFO
  });

  return <>
    {(props?.user.portal === GlobalConstants.Portals.LMS || hideMenu) && (
      <React.Fragment>
        {!props.isGreaterThanTablet && (
          <BCError
            isGreaterThanTablet={props.isGreaterThanTablet}
            isSidebar={props.isSidebar}
            errorPage={ErrorPages.SCREEN_SIZE_NOT_SUPPORTED}
          />
        )}
        {props.isGreaterThanTablet && (
          <div className={`${props.isGreaterThanTablet && props.isSidebar ? "hide-sidebar" : "sidebar"}`}>
            <BCErrorBoundary>
              {info && info.message && (
                <LmsMessage
                  isInfo={info.type !== GlobalConstants.ErrorLevels.ERROR}
                  header={info.header}
                  text={info.message}
                  funcOnClose={clearGlobalInfo}
                  skipAutoClose={!!info.skipAutoClose}
                />
              )}
              <div className={hideMenu ? "lms-iframe-landing-page" : "lms-landing-page"}>
                <Card.Group>
                  {!hideMenu && <LMSTabFilter />}
                  <Card fluid className="lms-breadcrumb-menu-container">
                    <LmsBreadcrumbsMenu history={history} />
                    <Icon name={GlobalConstants.Icons.CLOSE as any} onClick={() => history.goBack()} />
                  </Card>
                </Card.Group>
                <>
                  {children}
                </>
              </div>
            </BCErrorBoundary>
            {!!iFrameOptions?.modalIframeSrcPath && <BCModal
              isModalOpen
              size={iFrameOptions?.iframeModalSize || "fullscreen"}
              closeIcon
              onClose={() => closeIframeModal()}
              content={(
                <iframe
                  ref={iframeModalRef}
                  src={iFrameOptions?.modalIframeSrcPath}
                  width="100%"
                  height={iFrameOptions.iframeModalHeight || iframeModalHeight || 600}
                  style={{ border: "none" }}
                  onLoad={handleIframeLoad} />
              )}
            />}
          </div>
        )}
      </React.Fragment>
    )}
    {(props?.user?.portal !== GlobalConstants.Portals.LMS && !hideMenu) && (
      <BCErrorBoundary>
        <Redirect to="/" />
      </BCErrorBoundary>
    )}
  </>;
};

const LmsLayout = ({ children, user, bcLayoutProps, ...props }) => {
  const [popupTitle] = useLocalStorage("popupTitle", "", "session");
  const hideMenu = !!(popupTitle || window?.frameElement);
  if (popupTitle) {
    document.title = popupTitle;
  }

  return <AuthWrapper>
    {hideMenu && <LmsPages {...props} hideMenu user={user}>{children}</LmsPages>}
    {!hideMenu && (
      <BCLayout {...bcLayoutProps}>
        <LmsPages {...props} user={user} hideMenu={hideMenu}>{children}</LmsPages>
      </BCLayout>
    )}
  </AuthWrapper>;
};

export default LmsLayout;